import { inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RestApiService } from '@App/common/services';
import { Observable } from 'rxjs';

// TODO: Check service
@Injectable({ providedIn: 'root' })
export class CustomerAnalyticsService {
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly restApiService = inject(RestApiService);

  addReview(params: object): Observable<any> {
    return this.restApiService.post(
      'add-review',
      'customer-analytics/add-review',
      params,
      true
    );
  }

  getBusinessVideoReviewList(id: any, config: any): Observable<any> {
        const isEmbeded = window.location.pathname.includes('embedded-card')

    return this.restApiService.get(
      'get-business-video_review-list',
      `customer-analytics/${id}/reviews?${isEmbeded ? 'draft=true&' : ''}${this.restApiService.convertObjToQueryParams(
        config
      )}`
    );
  }

  getAllBusinessVideoReviewList(id: any, config: any): Observable<any> {
    return this.restApiService.get(
      'get-all-review-list',
      `customer-analytics/${id}/all-reviews?${this.restApiService.convertObjToQueryParams(
        config
      )}`
    );
  }

  reportIssues(id: string, params: object): Observable<any> {
    return this.restApiService.get(
      'report-review',
      `customer-analytics/${id}/report-review?${this.restApiService.convertObjToQueryParams(
        params
      )}`,
      true
    );
  }

  getReportAnalytics(params: any): Observable<any> {
    const queryParams: any = {
      fromDate: params.fromDate,
      toDate: params.toDate,
      types: params.types,
      businessId: params.businessId
    };
    if (params.orgId) {
      queryParams['orgId'] = params.orgId;
    }
    if (params.businessId) {
      queryParams['businessId'] = params.businessId;
    }
    return this.restApiService.get(
      'get-report-analytics',
      'customer-analytics/report',
      true,
      queryParams
    );
  }

  deleteTestimonial(reviewId: string, cacheId?: string): Observable<any> {
    return this.restApiService.post(
      'delete-review',
      `customer-analytics/${reviewId}/delete-review`,
      true,
      true,
      cacheId ? { cacheId } : {}
    );
  }

  setApproveTestimonial(reviewId: string, cacheId?: string): Observable<any> {
    return this.restApiService.put(
      'set-approve-review',
      `customer-analytics/${reviewId}/change-visible`,
      true,
      true,
      cacheId ? { cacheId } : {}
    );
  }

  updateNewTestimonials(data: any[], cacheId?: string): Observable<any> {
    return this.restApiService.post(
      'set-approve-review',
      `customer-analytics/add-viewer-review${
        cacheId ? `?cacheId=${cacheId}` : ''
      }`,
      data,
      true
    );
  }
}
